import * as ActionTypes from '../../actions/actionTypes'

/** @reducer **/
export default (state = null, action) => {
    switch (action.type) {
        case ActionTypes.H24_CURRENT_ORGANIZATION_CHANGE:
            return action.data
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/h24Reducers/h24CurrentOrganization.js